export default __webpack_public_path__ + "static/zdd_podcast_logo-8f0be70da241591adaef6221541d792f.svg";